(function () {
  'use strict';

  if (window.__nestPdpDefaultHighestRated20260816) return;
  if (!/^\/products\//.test(window.location.pathname)) return;
  window.__nestPdpDefaultHighestRated20260816 = 'v7-paginated-sort-state';

  var initialRequestRewritten = false;
  var canonicalReviewPath = '';
  var canonicalReviewSort = 'rating';
  var canonicalReviewDirection = 'desc';

  function rewriteInitialReviewRequest(url) {
    if (typeof url !== 'string') return url;

    var parsed;
    try {
      parsed = new URL(url, window.location.href);
    } catch (error) {
      return url;
    }

    var isYotpoProductReviewRequest =
      /(^|\.)yotpo\.com$/i.test(parsed.hostname) &&
      /\/products\/[^/]+\/reviews\.json$/i.test(parsed.pathname) &&
      parsed.pathname.indexOf('/products/yotpo_site_reviews/') === -1;

    if (!isYotpoProductReviewRequest) return url;

    if (!canonicalReviewPath) canonicalReviewPath = parsed.pathname;
    else parsed.pathname = canonicalReviewPath;

    if (!initialRequestRewritten) {
      initialRequestRewritten = true;
      parsed.searchParams.set('sort', canonicalReviewSort);
      parsed.searchParams.set('direction', canonicalReviewDirection);
    } else {
      if (!parsed.searchParams.has('sort')) parsed.searchParams.set('sort', canonicalReviewSort);
      if (!parsed.searchParams.has('direction')) parsed.searchParams.set('direction', canonicalReviewDirection);
    }
    return parsed.toString();
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      if (typeof input === 'string') {
        input = rewriteInitialReviewRequest(input);
      } else if (window.Request && input instanceof window.Request) {
        var rewritten = rewriteInitialReviewRequest(input.url);
        if (rewritten !== input.url) input = new Request(rewritten, input);
      }
      return nativeFetch.call(this, input, init);
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype.open) {
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      var args = Array.prototype.slice.call(arguments);
      args[1] = rewriteInitialReviewRequest(url);
      return nativeOpen.apply(this, args);
    };
  }


  function installReviewCap(root) {
    if (root.getAttribute('data-nest-review-cap') === '10-v1') return;
    root.setAttribute('data-nest-review-cap', '10-v1');

    var grid = root.querySelector('.reviews-grid');
    var moreButton = root.querySelector('.more-reviews');
    var visibleLimit = 10;
    var scheduled = false;

    function reviewCards() {
      var cards = Array.prototype.filter.call(grid.children, function (child) {
        return child.matches('.review-customization, article, [data-review-id]');
      });
      return cards.length ? cards : Array.prototype.slice.call(grid.children);
    }

    function applyCap() {
      scheduled = false;
      var cards = reviewCards();
      cards.forEach(function (card, index) {
        if (index < visibleLimit) {
          card.style.removeProperty('display');
          card.removeAttribute('aria-hidden');
        } else {
          card.style.setProperty('display', 'none', 'important');
          card.setAttribute('aria-hidden', 'true');
        }
      });

      if (moreButton && cards.length > visibleLimit) {
        moreButton.style.setProperty('display', 'inline-flex', 'important');
        moreButton.removeAttribute('hidden');
        moreButton.setAttribute('aria-hidden', 'false');
      }
    }

    function scheduleCap() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(applyCap);
    }

    root.addEventListener('click', function (event) {

      var readMore = event.target.closest('.more-reviews');
      if (!readMore) return;
      var hiddenCards = reviewCards().filter(function (card) {
        return card.getAttribute('aria-hidden') === 'true';
      });
      visibleLimit += 10;
      if (hiddenCards.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        scheduleCap();
      } else {
        window.setTimeout(scheduleCap, 100);
        window.setTimeout(scheduleCap, 700);
      }
    }, true);

    if (window.MutationObserver) {
      new MutationObserver(scheduleCap).observe(grid, { childList: true });
    }
    applyCap();
  }

  function applyHighestRatedDefault() {
    var roots = document.querySelectorAll(
      '.product-reviews-api:not([data-product-id="yotpo_site_reviews"])'
    );

    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-nest-default-sort') === 'highest-rated-20260816-v7') return;

      var attempts = 0;
      function retry() {
        var grid = root.querySelector('.reviews-grid');

        if (!grid || grid.children.length === 0) {
          attempts += 1;
          if (attempts < 80) window.setTimeout(retry, 250);
          return;
        }

        root.setAttribute('data-nest-default-sort', 'highest-rated-20260816-v7');
        installReviewCap(root);
      }

      retry();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(applyHighestRatedDefault, 250);
    }, { once: true });
  } else {
    window.setTimeout(applyHighestRatedDefault, 250);
  }
})();
